import { axiosConfig } from './axios-config.js'

export const store = {
  // 取得門市
  get: (id, token) => axiosConfig.get(`/api/console/store/${id}`, token),

  // 創建門市
  create: (data, token) => axiosConfig.post('/api/console/store', data, token),

  // 更新門市
  update: (id, data, token) => axiosConfig.patch(`/api/console/store/${id}`, data, token),

  // 刪除門市
  delete: (id, token) => axiosConfig.delete(`/api/console/store/${id}`, token),

  // 排序門市
  sort: (data, token) => axiosConfig.patch('/api/console/store/sort', data, token)
}
